export default __webpack_public_path__ + "static/media/vehicle-group-small-icon.53c7a431.svg";